import moment from "moment";
import { getDateInMoment } from "../../../libraries/form/utilities/dateParser";
export const maintenanceTranslateInterface = {
  isValidCoordinates: (lat, lon) => {
    // Must be real numbers
    if (typeof lat !== "number" || typeof lon !== "number") return false;
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return false;

    // Must be in valid geographic range
    if (lat < -90 || lat > 90) return false;
    if (lon < -180 || lon > 180) return false;

    return true;
  },
  isLikelyRealCoordinates: (fields) => {
    if (fields.startLat && fields.startLon) {
      if (!maintenanceTranslateInterface.isValidCoordinates(parseFloat(fields.startLat), parseFloat(fields.startLon))) return false;
      return true;
    } else {
      return true;
    }
  },
  addNewMaintenance: (fields, { documentList, imgList }, { locations, assets }) => {
    const { observation, submittal, fdotId, associated, bridge, site } = fields;
    let mpFields = {};
    let additionalFields = {};
    if (fields.startMp) mpFields.startMp = fields.startMp;
    if (fields.endMp) mpFields.endMp = fields.endMp;
    if (fields.addHistorical) additionalFields.closedDate = getDateInMoment(new Date());
    if (fields.closedDate) additionalFields.closedDate = fields.closedDate;
    if (observation || submittal || fdotId || associated || bridge || site) {
      let fdotId = "";
      const trimmedSubmittal = submittal && submittal.trim();
      const trimmedObservation = observation && observation.trim();

      if (trimmedSubmittal && trimmedObservation) {
        fdotId = `${trimmedSubmittal} - ${trimmedObservation}`;
      } else if (trimmedSubmittal) {
        fdotId = trimmedSubmittal;
      } else if (trimmedObservation) {
        fdotId = trimmedObservation;
      }

      additionalFields.bridge = {
        observation: observation,
        submittal: submittal,
        fdotId: fdotId,
        associated: associated,
        bridge: bridge,
        site: site,
      };
    }

    let maintenance = {
      documents: documentList,
      lineId: fields.lineId,
      lineName: maintenanceTranslateInterface.loadLocationName(fields.lineId, locations), // load from method
      maintenanceType: fields.maintenanceType || "other",
      chargeCode: fields.chargeCode,
      priority: fields.priority,
      dueDate: (fields.dueDate && new Date(fields.dueDate)) || null,
      afeNumber: fields.afeNumber,
      issue: {
        description: fields.description,
        title: fields.description,
        voiceNotes: fields.voiceNotes,
        // default fields for web issue
        timeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss.SSS"),
        imgList: imgList.map((image) => {
          return { imgName: image, md5: null, status: 1, tag: "before" };
        }),

        issueType: "Deficiency",
        locUnit: "MP",
        location: maintenanceTranslateInterface.loadGPS(fields),
        voiceList: [],
        tags: [],
        defectCodes: [],
        marked: false,
        ruleApplied: false,
        unit: maintenanceTranslateInterface.loadAssetUnit(fields, assets),
        ...mpFields,
      },
      ...additionalFields,
    };
    return maintenance;
  },
  loadAssetUnit: (fields, assets) => {
    let asset = assets.find((a) => a._id === fields.assetId);
    let parentAsset = assets.find((pa) => pa._id === asset.parentAsset);
    let markerFields = {};
    if (asset.markerStart) markerFields.startMarker = asset.markerStart;
    if (asset.markerEnd) markerFields.endMarker = asset.markerEnd;
    return {
      id: asset._id,
      unitId: asset.unitId,
      start: asset.start,
      end: asset.end,
      assetType: asset.assetType,
      coordinates: [],
      parent_id: parentAsset._id,
      attributes: {},
      testForm: [],
      freeze: false,
      parentAsset: {
        assetType: parentAsset.assetType,
        _id: parentAsset._id,
        unitId: parentAsset.unitId,
      },
      ...markerFields,
    };
  },
  loadLocationName: (lineId, locations) => {
    let loc = locations.find((l) => l._id === lineId);
    if (loc) return loc.unitId;
    return "";
  },
  loadGPS: (fields) => {
    if (fields.startLat && fields.startLon && fields.addGps) return `${fields.startLat},${fields.startLon}`;
    return "";
  },
};

export const maintenanceEditLoadMethod = {
  loadEditMFields: (selectedMaintenance) => {
    let mpFields = {};
    let additionalFields = {};
    if (selectedMaintenance.issue.startMp) mpFields.startMp = selectedMaintenance.issue.startMp;
    if (selectedMaintenance.issue.endMp) mpFields.endMp = selectedMaintenance.issue.endMp;
    if (selectedMaintenance.closedDate) additionalFields.closedDate = selectedMaintenance.closedDate;
    if (selectedMaintenance.issue.location) {
      additionalFields.addGps = true;
      let locSplit = selectedMaintenance.issue.location.split(",");
      additionalFields.startLat = (locSplit[0] || "").trim();
      additionalFields.startLon = (locSplit[1] || "").trim();
    }
    if (selectedMaintenance.bridge) additionalFields = { ...additionalFields, ...selectedMaintenance.bridge };

    return {
      afeNumber: selectedMaintenance.afeNumber || "",
      assetId: maintenanceEditLoadMethod.loadEditUnit(selectedMaintenance),
      description: selectedMaintenance.issue.description || "",
      dueDate: (selectedMaintenance.dueDate && moment(selectedMaintenance.dueDate)) || null,
      lineId: selectedMaintenance.lineId || "",
      maintenanceType: selectedMaintenance.maintenanceType || "",
      chargeCode: selectedMaintenance.chargeCode || "",
      priority: selectedMaintenance.priority,
      voiceNotes: selectedMaintenance.issue.voiceNotes || "",
      mrNumber: selectedMaintenance.mrNumber,
      ...mpFields,
      ...additionalFields,
    };
  },
  loadEditUnit: (selectedMaintenance) => {
    return (selectedMaintenance && selectedMaintenance.issue && selectedMaintenance.issue.unit && selectedMaintenance.issue.unit.id) || "";
  },

  loadEditImageDocument: (selectedMaintenance) => {
    let imageList = selectedMaintenance.issue.imgList ? selectedMaintenance.issue.imgList.map((item) => item.imgName) : [];
    let documentList = selectedMaintenance.documents ? selectedMaintenance.documents.map((item) => item) : [];

    return {
      imageList: imageList,
      documentList: documentList,
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenanceV2/maintenanceTranslator.js